import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {RouterProvider} from "react-router";
import router from "./routing/router";
import {CssBaseline, ThemeProvider} from "@mui/material";
import {theme} from "./styling/theme";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline>
                <RouterProvider router={router}/>
            </CssBaseline>
        </ThemeProvider>

    </React.StrictMode>
);

reportWebVitals();
